import { getOptions } from "@services/api.services";
import { baseURL } from "@services/index.services";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getObjQuery } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { useEffect, useState } from "react";

// interface ApiResponse<T> {
//   count: number;
//   next: string | null;
//   previous: string | null;
//   results: T[];
// }

const useInfiniteScroller = ({
  endpoint = "",
  filter = {},
  enabled = false,
  key = "",
}) => {
  const fetchRequest = async ({ pageParam = 1 }): Promise<any> => {
    const size = 10;
    const res = await fetch(
      `${baseURL}${endpoint}?page=${pageParam}&size=${size}&ordering=order&${getObjQuery(
        filter
      )}`,
      getOptions()
    );
    if (!res.ok) throw new Error("Failed to fetch universities");
    return res.json();
  };
  const pathname = usePathname();
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    isPending,
    refetch,
  } = useInfiniteQuery<any, Error>({
    queryKey: [`${pathname}-listing-scroll`, filter, key],
    // @ts-ignore
    queryFn: fetchRequest,
    staleTime: 0,
    getNextPageParam: (lastPage: any, _) => {
      if (lastPage.next) {
        const url = new URL(lastPage.next);
        const nextPage = url.searchParams.get("page");
        return nextPage ? parseInt(nextPage) : undefined;
      }
      return undefined;
    },
    enabled,
  });

  return {
    status,
    data,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    isPending,
    refetch,
  };
};
const useDebounce = ({
  initalValue,
  delay,
}: {
  initalValue: string;
  delay: number;
}): string => {
  const [value, setValue] = useState<string>("");
  useEffect(() => {
    const timer = setTimeout(() => {
      setValue(initalValue);
    }, delay);
    return () => clearTimeout(timer);
  }, [initalValue]);
  return value;
};

export { useDebounce, useInfiniteScroller };
